/**
 * GA4 Experiment Event Tracker
 * Shady Rays — Shopify Storefront
 *
 * Usage:
 *   ShadyRaysGA4.track('women_experience')
 *   ShadyRaysGA4.track('first_moment_of_truth')
 *   ShadyRaysGA4.track('adaptive_shopping_experience')
 *
 * Call this whenever the experiment is activated/enabled on the page.
 * Safe to call multiple times — deduplicates per session per experiment.
 */

window.ShadyRaysGA4 = (function () {

  // ─── Experiment definitions ──────────────────────────────────────────────
  // Map your internal experiment key → GA4 event payload
  var EXPERIMENTS = {
    women_experience: {
      event_name: 'experiment_activated',
      params: {
        experiment_id:   'women_experience',
        experiment_name: 'Women Experience',
        variant:         'enabled'
      }
    },
    first_moment_of_truth: {
      event_name: 'experiment_activated',
      params: {
        experiment_id:   'first_moment_of_truth',
        experiment_name: 'First Moment of Truth',
        variant:         'enabled'
      }
    },
    adaptive_shopping_experience: {
      event_name: 'experiment_activated',
      params: {
        experiment_id:   'adaptive_shopping_experience',
        experiment_name: 'Adaptive Shopping Experience',
        variant:         'enabled'
      }
    }
  };

  // ─── Config ───────────────────────────────────────────────────────────────
  var MAX_WAIT_MS    = 10000;  // Give up after 10 seconds
  var INTERVAL_MS    = 300;   // Recheck every 300ms
  var SESSION_PREFIX = 'sr_ga4_sent_'; // sessionStorage key prefix

  // ─── Internal: fire when gtag is confirmed ready ─────────────────────────
  function _fireEvent(experimentKey) {
    var config = EXPERIMENTS[experimentKey];

    if (!config) {
      console.warn('[ShadyRaysGA4] Unknown experiment key: "' + experimentKey + '"');
      return;
    }

    // Deduplicate: don't fire the same experiment twice in one session
    var sessionKey = SESSION_PREFIX + experimentKey;
    if (sessionStorage.getItem(sessionKey)) {
      console.log('[ShadyRaysGA4] Already fired this session: ' + experimentKey);
      return;
    }

    // Fire the GA4 event
    gtag('event', config.event_name, config.params);

    // Mark as sent for this session
    sessionStorage.setItem(sessionKey, '1');

    console.log('[ShadyRaysGA4] Event fired:', config.event_name, config.params);
  }

  // ─── Internal: wait for gtag, then fire ──────────────────────────────────
  function _waitForGtag(experimentKey) {
    var elapsed = 0;

    // If gtag is already there, fire immediately
    if (typeof window.gtag === 'function') {
      _fireEvent(experimentKey);
      return;
    }

    console.log('[ShadyRaysGA4] gtag not ready, polling... (' + experimentKey + ')');

    var interval = setInterval(function () {
      elapsed += INTERVAL_MS;

      if (typeof window.gtag === 'function') {
        clearInterval(interval);
        console.log('[ShadyRaysGA4] gtag ready after ' + elapsed + 'ms');
        _fireEvent(experimentKey);
        return;
      }

      if (elapsed >= MAX_WAIT_MS) {
        clearInterval(interval);
        console.warn('[ShadyRaysGA4] gtag not available after ' + MAX_WAIT_MS + 'ms — giving up for: ' + experimentKey);
      }
    }, INTERVAL_MS);
  }

  // ─── Public API ───────────────────────────────────────────────────────────
  return {
    /**
     * Track an experiment activation.
     * @param {string} experimentKey - One of: 'women_experience', 'first_moment_of_truth', 'adaptive_shopping_experience'
     * @param {Object} [extraParams]  - Optional extra params to merge into the event (e.g. { variant: 'v2' })
     */
    track: function (experimentKey, extraParams) {

      if (!experimentKey) {
        console.warn('[ShadyRaysGA4] track() called with no experimentKey');
        return;
      }

      // Allow caller to override/extend params at call time
      if (extraParams && EXPERIMENTS[experimentKey]) {
        EXPERIMENTS[experimentKey].params = Object.assign(
          {},
          EXPERIMENTS[experimentKey].params,
          extraParams
        );
      }

      _waitForGtag(experimentKey);
    },

    /**
     * Reset session deduplication for a key (useful during dev/testing).
     * @param {string} experimentKey
     */
    reset: function (experimentKey) {
      sessionStorage.removeItem(SESSION_PREFIX + experimentKey);
      console.log('[ShadyRaysGA4] Reset session flag for: ' + experimentKey);
    },

    /**
     * Reset all experiment session flags.
     */
    resetAll: function () {
      Object.keys(EXPERIMENTS).forEach(function (key) {
        sessionStorage.removeItem(SESSION_PREFIX + key);
      });
      console.log('[ShadyRaysGA4] All session flags reset.');
    }
  };

})();
